import React from 'react'
import MainActions from './MainActions'
import UserMenu from './UserMenu'
import style from './style.module.scss'
import { useHistory, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { useData } from '../../../../contexts/data-context'
import { isIframe } from '../../../../services/utils'
import AppsMenu from './AppsMenu'

const mapStateToProps = ({ settings }) => ({
  logo: settings.logo,
})

const TopBar = ({ logo }) => {
  const history = useHistory()
  const { product, payment_link, default_dataset } = useData()

  const title = {
    answersearch: 'Answer Search for Zendesk',
    macrosearch: 'Macro Search for Zendesk',
    translate: 'Translate Conversations for Zendesk',
    cowriter: 'Agent Co-writer for Zendesk',
    exportPdfs: 'Articles PDF Export for Zendesk',
    mcpserver: 'Zendesk MCP Server',
    easydoc: 'Help Center Export for Zendesk Guide',
    macroexport: 'Macros Export for Zendesk Support',
    hcmanager: 'Help Center Export for Zendesk Guide',
    mergedup: 'Merge Duplicate Tickets',
    removecc: 'Remove CC from Zendesk Tickets',
    attachments: 'Attachment Workflows for Zendesk',
    redact: 'Auto Remove Attachments for Zendesk',
    lookup: 'Ticket Parser Autofill for Zendesk',
    triggers_gpt: 'Triggers+ChatGPT for Zendesk',
    classify: 'Ticket Classification',
    document_parser: 'Document Parser OCR',
    resolveloop: 'ResolveLoop',
    admin: 'Admin Dashboard',
  }

  const use_local_payment = ['redact', 'mergedup', 'triggers_gpt', 'classify', 'lookup', 'document_parser'].includes(product);

  const go_home = e => {
    e.preventDefault()
    history.push('/')
  }

  return (
    <div className={`${style.topbar} ${isIframe() ? '' : style.bottomMargin}`}>
      <div className="mb-0 mr-auto d-xl-block">
        {!isIframe() && (
          <div className={style.logoContainer}>
            <div className={style.logo}>
              <a onClick={go_home}>
                <img
                  src="../resources/images/logo.svg"
                  className={`mr-2 ${style.logoImage}`}
                  alt="Swifteq"
                />
              </a>
              {/*<div className={style.name}>{logo}</div>*/}
              <div className={style.descr}>{title[product] || 'Loading...'}</div>
            </div>
          </div>
        )}
      </div>
      <div className="d-flex ">
        {product === 'mergedup' && (
          <a
            className="btn btn-small align-middle mr-3"
            style={{ height: '50%'}}
            href="https://support.swifteq.com/hc/en-us/categories/21944208295441-Merge-Duplicate-Tickets"
            target="_blank"
            type="button"
          >
            <i className="fe fe-help-circle mr-1 font-size-14" /> Online Help
          </a>
        )}
        {product === 'redact' && (
          <a
            className="btn btn-small align-middle mr-3"
            style={{ height: '50%'}}
            href="https://support.swifteq.com/hc/en-us/categories/21986668718481-Auto-Remove-Attachments"
            target="_blank"
            type="button"
          >
            <i className="fe fe-help-circle mr-1 font-size-14" /> Online Help
          </a>
        )}
        {product === 'triggers_gpt' && (
          <a
            className="btn btn-small align-middle mr-3"
            style={{ height: '50%'}}
            href="https://support.swifteq.com/hc/en-us/categories/22208132992529-Triggers-ChatGPT"
            target="_blank"
            type="button"
          >
            <i className="fe fe-help-circle mr-1 font-size-14" /> Online Help
          </a>
        )}
        {(product === 'translate' || product === 'cowriter') && (
          <a
            className="btn btn-small align-middle mr-3"
            style={{ height: '50%'}}
            href="https://support.swifteq.com/hc/en-us/categories/22224340562065-Translate-Conversations"
            target="_blank"
            type="button"
          >
            <i className="fe fe-help-circle mr-1 font-size-14" /> Online Help
          </a>
        )}
        {(!default_dataset?.is_customer && (payment_link || use_local_payment)) && (
          <a
            className="btn btn-primary btn-small align-middle mr-5"
            style={{ height: '50%' }}
            href={(use_local_payment) ? '/payment' : payment_link}
            target={(use_local_payment) ? '_self' : '_blank'}
            type="button"
          >
            Subscribe
          </a>
        )}
        {(!default_dataset || default_dataset?.source === 'zendesk_support') && <AppsMenu />}
        <UserMenu />
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(TopBar)
